class HubSlideshow {
  constructor() {
    this.swiperInstances = new Map();
    this.initializeSlideshows();
    this.bindThemeEditorEvents();
  }

  initializeSlideshows() {
    const sliders = document.querySelectorAll(".component-hub-slideshow");
    sliders.forEach((slider) => {
      this.initializeSlider(slider);
    });
  }

  initializeSlider(slider) {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded');
      return;
    }

    const id = slider.getAttribute("id");
    if (!id) return;

    if (this.swiperInstances.has(id)) {
      this.swiperInstances.get(id).destroy(true, true);
    }

    const slidesCount = slider.querySelectorAll('.swiper-slide').length;
    if (slidesCount === 0) return;

    try {
      const swiperInstance = new Swiper(`#${id}`, {
        direction: "horizontal",
        slidesPerView: slidesCount === 1 ? 1 : 1.5,
        spaceBetween: 10,
        simulateTouch: true,
        allowTouchMove: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: Math.min(slidesCount, 3),
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: Math.min(slidesCount, 4),
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        on: {
          init: function() {
            this.update();
          }
        }
      });

      this.swiperInstances.set(id, swiperInstance);
    } catch (error) {
      console.error('Error initializing slideshow:', error);
    }
  }

  bindThemeEditorEvents() {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;

    document.addEventListener('shopify:section:load', (event) => {
      const sliders = event.target.querySelectorAll('.component-hub-slideshow');
      sliders.forEach((slider) => this.initializeSlider(slider));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sliders = event.target.querySelectorAll('.component-hub-slideshow');
      sliders.forEach((slider) => {
        const id = slider.getAttribute('id');
        if (this.swiperInstances.has(id)) {
          this.swiperInstances.get(id).destroy(true, true);
          this.swiperInstances.delete(id);
        }
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slider = event.target.querySelector('.component-hub-slideshow');
      if (slider) {
        const id = slider.getAttribute('id');
        if (this.swiperInstances.has(id)) {
          this.swiperInstances.get(id).update();
        }
      }
    });
  }

  destroy() {
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
    this.swiperInstances.clear();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HubSlideshow();
  });
} else {
  new HubSlideshow();
}
